import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetClientPublicationsQueryResponse, GetClientPublicationsQueryParams } from "../types/GetClientPublications";

export const getClientPublicationsQueryKey = (params: GetClientPublicationsQueryParams) =>     [{url:`/api/ms-content-infoportal-backend/v1/publications`},...(params ? [params] : [])] as const;
      export function getClientPublicationsQueryOptions <TData = GetClientPublicationsQueryResponse, TError = unknown>(params: GetClientPublicationsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getClientPublicationsQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/ms-content-infoportal-backend/v1/publications`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/ms-content-infoportal-backend/v1/publications
 */

export function useGetClientPublications <TData = GetClientPublicationsQueryResponse, TError = unknown>(params: GetClientPublicationsQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getClientPublicationsQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getClientPublicationsQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
